import React, { useEffect, useState } from 'react';
import Styles from './styles.module.scss';

const CountdownTimer = ({ onComplete }) => {
    const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 минут в секундах

    useEffect(() => {
        if (timeLeft <= 0) {
            onComplete(); // вызываем колбэк, когда время истекло
            return;
        }

        const timerId = setInterval(() => {
            setTimeLeft(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timerId); // очистка при размонтировании
    }, [timeLeft, onComplete]);

    const formatTime = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, '0');
        const s = String(seconds % 60).padStart(2, '0');
        return `${m}:${s}`;
    };

    return (
        <section className={`${Styles.container}`}>
            {formatTime(timeLeft)}
        </section>
    );
};

export default CountdownTimer;